module.exports = __webpack_public_path__ + "img/fast_car.6e7cb106.svg";